<template>
  <div class="card">
    <div class="cardBox">
      <div class="cardTop">
        <img
          src="../../../assets/images/shippingCommission/waybill.png"
          class="copy"
        />
        <CopyButton :index="prop.index" :text="prop.data.waybillCode" />
      </div>
      <span
        class="waybill"
        :style="{ color: listTag[prop.data.auditedStatus].color }"
        >{{ listTag[prop.data.auditedStatus].name }}</span
      >
    </div>
    <div class="cardBottom">
      <van-button
        v-if="prop.data.auditedStatus !== 1"
        plain
        type="default"
        class="view"
        round
        @click="() => view('view')"
        >{{ lang('查看详情') }}</van-button
      >
      <van-button
        v-if="prop.data.auditedStatus === 4"
        class="edit"
        color="linear-gradient(to right, #FA510F, #FF0000)"
        round
        @click="() => view('edit')"
      >
        {{ lang('编辑') }}
      </van-button>
      <van-button
        v-if="prop.data.auditedStatus === 1"
        class="edit"
        color="linear-gradient(to right, #FA510F, #FF0000)"
        round
        @click="() => view('upload')"
      >
        {{ lang('上传') }}
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import lang from '@/langs'
import CopyButton from '@/components/CopyButton.vue'
import { PropType, ref } from 'vue'
import { WaybillRecord } from '@/model/cancelUpload/cancelUpload'
const tag = ref(1)
const emit = defineEmits(['toDetail'])
const view = (value: 'edit' | 'upload' | 'view', data: WaybillRecord) => {
  emit('toDetail', value)
}
const prop = defineProps({
  data: {
    type: Object as PropType<WaybillRecord>,
    default: () => {}
  },
  index: {
    type: Number,
    default: 0
  }
})
const listTag = [
  { name: lang('全部'), value: 0, color: '#B7B7B7' },
  { name: lang('待上传'), value: 1, color: '#FFAB19' },
  { name: lang('待审核'), value: 2, color: '#FFAB19' },
  { name: lang('已完成'), value: 3, color: '#B7B7B7' },
  { name: lang('已驳回'), value: 4, color: '#FF0000' }
]
</script>

<style scoped lang="less">
.card {
  background: #fff;
  border-radius: 7px;
  padding: 18px 16px;
  margin: 10px 12px;
  .cardBox {
    display: flex;
    flex-direction: row;
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid #f2f2f2;
    justify-content: space-between;
    .waybill {
      font-size: 14px;
    }
    .cardTop {
      display: flex;
      flex-direction: row;
      align-items: center;
      .waybill {
        font-size: 14px;
      }
      .copy {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
  }
  .cardBottom {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    .view {
      min-width: 100px;
      height: 33px;
    }
    .edit {
      min-width: 100px;
      height: 33px;
      margin-left: 8px;
    }
  }
}
</style>
